import { render, staticRenderFns } from "./particularTmpl.vue?vue&type=template&id=6e822e29&scoped=true&"
import script from "./particularTmpl.vue?vue&type=script&lang=js&"
export * from "./particularTmpl.vue?vue&type=script&lang=js&"
import style0 from "./particularTmpl.vue?vue&type=style&index=0&id=6e822e29&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e822e29",
  null
  
)

export default component.exports